import Colors from "./Colors";

export default {
    colors: {
        primary: Colors.elementSelected,
        background: Colors.whiteBackground,
    }
};